import React, { Component } from 'react';
import { imageAddress, textVariableReplacer, translate } from '../../utils/useful';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import IconMap from './IconMap';
import { saveAs } from 'file-saver';
import StagesManager from '../../components/StagesManager';

class FilePreview extends Component {

    state = {
        imageExtentions: ['png', 'jpg', 'jpeg', 'svg'],
        videoExtentions: ['mp4']
    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {

        if (prevProps.data != this.props.data) {
            this.init()
        }

    }


    init = () => {

        let data = this.props.data
        if (this.state.imageExtentions.includes(data.extension.toLowerCase())) {
            this.stageManager.changeStage('image')
            return
        }

        if (this.state.videoExtentions.includes(data.extension.toLowerCase())) {
            this.stageManager.changeStage('video')
            return
        }

        this.stageManager.changeStage('noPreview')

    }



    downloadFile = (fullData, extra, info) => {
        let file = 'test.png'
        let data = textVariableReplacer(fullData, fullData.address, '', 'downloaaaad')
        if (Array.isArray(this.props.params)) {
            for (let i = 0; i < this.props.params.length; i++) {
                const param = this.props.params[i];
                data = this.textVariableReplacer(param?.info, data, param.fields, param.label)

            }
        }
        saveAs(imageAddress(data))

    }

    render() {
        let data = this.props.data
        return (
            <div className='w-100 h-100' >

                <StagesManager ref={el => this.stageManager = el} height={'100%'} className={'flex-1 w-100'} fast={true}  >

                    <div stageName='image' stage={1} className='h-100'>

                        {/* <div className="flexce w-100 px-3 py-2" style={{ backgroundColor: '#fff', }}>
                            <div className="flexc mrd-2">
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => { this.downloadFile(data) }}
                                    title={translate('Download')}
                                    icon='/assets/icons/drive/dl-white.svg'
                                    textColor={'#fff'}
                                    bg={this.props.colors ? this.props.colors.background : '#6B00B6'}
                                />
                            </div>
                            <div className="flexc mld-2">
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => this.props.shareModal()}
                                    title={translate('Share')}
                                    icon='/assets/icons/drive/share-white.svg'
                                    textColor={'#fff'}
                                    bg={this.props.colors ? this.props.colors.background : '#6B00B6'}
                                />
                            </div>
                        </div> */}
                        <div className='w-100 flexcc px-3 pb-2' style={{ height: 'calc(100%)' }}>
                            <img src={imageAddress(data.address, 'file', 'medium')} className='' style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '100%' }} alt='' />
                        </div>
                    </div>


                    <div stageName='video' stage={1} className='h-100'>
                        <div className='w-100 flexcc px-3 pb-2' style={{ height: 'calc(100%)' }}>
                            <video height="auto" className='br-10 ' controls={true} poster={imageAddress(data?.cover, 'videoCover', 'small')} style={{ objectFit: 'cover', maxWidth: '100%', maxHeight: '100%' }}>
                                <source src={imageAddress(data?.address)} type="video/mp4" />
                            </video>
                        </div>
                    </div>



                    <div stageName='noPreview' stage={1}>
                        <div className='flexcc white-bg br-10 px-4 py-5 flex-column' >
                            {/* <img src='/assets/icons/useful/page.png' height={80} alt='' /> */}

                            <div className="flexc flex-column w-100  ">
                                <div className="mb-2" style={{}}>

                                    <img className="flexcc" width={50} src={IconMap[this.props.data?.extension?.toLowerCase() ?? this.props.data?.type] ?? '/assets/icons/applets/drive/unknown.png'} alt="" draggable={false} style={{}} />
                                </div>
                                <p className='font-size-16 text-bold mld-2' style={{ color: '#222', wordBreak: 'break-word' }}>{this.props.data?.name}<span >{this.props.data?.extension && '.' + this.props.data?.extension}</span></p>
                            </div>

                            <div className='mt-3 flexc flex-column' style={{ borderTop: '1px solid #eee' }}>
                                <p className='font-size-14 mt-3 text-semibold'>{translate("No preview is available")}</p>

                                <div className="flexc mt-3">
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        imgWidth={14}
                                        onClick={() => { this.downloadFile(this.props.data) }}
                                        title={translate('Download')}
                                        icon='/assets/icons/useful/cloud-download.svg'
                                        textColor={'#fff'}
                                        invert={!this.props.colors?.iconInvert}
                                        bg={this.props.colors ? this.props.colors.background : '#6B00B6'}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>


                </StagesManager>
            </div>
        );

    }

}

export default FilePreview;